"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedaisparklessm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedaisparklessm` : '') + (description ? ` desc-brandedaisparklessm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedaisparklessm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedaisparklessm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#paint0_radial_27471_2513)",
    d: "M.56 12.783c.133-.073.27-.12.423-.136.21-.016 5.239-.536 5.952-6.177A1.08 1.08 0 0 1 8 5.51a.8.8 0 0 1 .27.041c.413.105.734.468.795.925.713 5.64 5.738 6.16 5.957 6.176.555.052.983.53.978 1.108a1.09 1.09 0 0 1-.983 1.098c-.21.015-5.239.535-5.952 6.176-.056.457-.377.819-.795.924A.8.8 0 0 1 8 22c-.54 0-.989-.41-1.065-.961-.713-5.64-5.738-6.16-5.957-6.176a.83.83 0 0 1-.417-.142A1.09 1.09 0 0 1 0 13.755a1.1 1.1 0 0 1 .56-.962z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#paint1_radial_27471_2513)",
    d: "M12.618 4.331c.128-.006 3.27-.325 3.716-3.745a.667.667 0 0 1 1.326 0c.446 3.42 3.588 3.739 3.722 3.745a.69.69 0 0 1 .618.675.67.67 0 0 1-.618.663c-.134.013-3.276.325-3.722 3.751a.67.67 0 0 1-.663.58.66.66 0 0 1-.663-.58c-.446-3.426-3.588-3.738-3.722-3.751A.67.67 0 0 1 12 4.994c0-.357.268-.637.618-.663"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#paint2_radial_27471_2513)",
    d: "M12.618 4.331c.128-.006 3.27-.325 3.716-3.745a.667.667 0 0 1 1.326 0c.446 3.42 3.588 3.739 3.722 3.745a.69.69 0 0 1 .618.675.67.67 0 0 1-.618.663c-.134.013-3.276.325-3.722 3.751a.67.67 0 0 1-.663.58.66.66 0 0 1-.663-.58c-.446-3.426-3.588-3.738-3.722-3.751A.67.67 0 0 1 12 4.994c0-.357.268-.637.618-.663"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("radialGradient", {
    id: "paint0_radial_27471_2513",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(16.6981 -16.6974 17.5471 18.1833 2.527 22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".004",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".293",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#cc0058"
  })), /*#__PURE__*/_react.default.createElement("radialGradient", {
    id: "paint1_radial_27471_2513",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(16.6981 -16.6974 17.5471 18.1833 2.527 22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".004",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".293",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#cc0058"
  })), /*#__PURE__*/_react.default.createElement("radialGradient", {
    id: "paint2_radial_27471_2513",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(16.6981 -16.6974 17.5471 18.1833 2.527 22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".004",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".293",
    stopColor: "#f04c24"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#cc0058"
  }))));
};
var _default = exports.default = brandedaisparklessm;